import moment from 'moment';
import { IAdviserState, IAdviserConnect } from '../../types';
import { AppActionTypes } from '../actions';
import { Types } from '../actions/adviser-actions';
import {
  isReferralAdviserConnect,
  sortByCreatedAtDesc,
  updateListByItemMerged,
} from 'helpers';

const checkIsConnected = (adviserConnects: IAdviserConnect[]) => {
  if (adviserConnects.length === 0) {
    return false;
  }
  const now = moment();
  const endBooking = R.path(
    ['calendlyEvent', 'resource', 'end_time'],
    adviserConnects[0],
  );
  return moment(endBooking).isAfter(now);
};

const advisersReducer = (
  state: IAdviserState,
  action: AppActionTypes,
): IAdviserState => {
  switch (action.type) {
    case Types.ADVISER_SUBMITTING:
      return {
        ...state,
        submitting: true,
      };
    case Types.GET_ALL_ADVISERS_LOADED:
      return {
        ...state,
        advisers: action.data,
      };
    case Types.GET_ADVISER_CONNECTS: {
      const adviserConnects = sortByCreatedAtDesc(action.data);
      return {
        ...state,
        adviserConnects,
        isConnected: checkIsConnected(adviserConnects),
        loaded: true,
      };
    }
    case Types.GET_ADVISER_CONNECT_LOADED: {
      return {
        ...state,
        premiumAdviserConnect: action.data,
        loading: false,
      };
    }
    case Types.CREATE_ADVISER_CONNECT: {
      const adviserConnects = sortByCreatedAtDesc([
        action.data,
        ...state.adviserConnects,
      ]);
      return {
        ...state,
        adviserConnects,
        // When adviser connect has policyProvider, its created via "Get Advice"
        premiumAdviserConnect: isReferralAdviserConnect(action.data)
          ? action.data
          : null,
        submitting: false,
        isConnected: true,
        loading: false,
      };
    }
    case Types.UPDATE_ADVISER_CONNECT: {
      const adviserConnects = updateListByItemMerged(
        state.adviserConnects,
        action.data,
      );
      return {
        ...state,
        adviserConnects,
        premiumAdviserConnect:
          action.data.id === state.premiumAdviserConnect?.id
            ? { ...state.premiumAdviserConnect, ...action.data }
            : state.premiumAdviserConnect,
        loading: false,
      };
    }
    case Types.CALENDY_EVENT_CREATED:
      return {
        ...state,
        calendly: {
          eventUrl: action.data.eventUrl,
        },
      };
    case Types.CALENDY_LOADING:
      return {
        ...state,
        loadingCalendar: action.data,
      };
    case Types.ADVISER_CONNECT_INFO_UPDATED:
      return {
        ...state,
        adviserConnectInfo: action.data,
      };
    case Types.ADVISER_RESET_FORM:
      return {
        ...state,
        submitted: false,
        submitting: false,
        error: null,
      };
    case Types.ADVISER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case Types.ADVISER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case Types.ADVISER_INQUIRY_LOADED:
      return {
        ...state,
        isInquired: true,
        loading: false,
      };
    default:
      return state;
  }
};

export default advisersReducer;
